export const getUrl = (path: string): string => {
    return `https://fakestoreapi.com/${path}`;
};
